import { render, staticRenderFns } from "./inventory-mask.vue?vue&type=template&id=edad7ae8&scoped=true&"
import script from "./inventory-mask.vue?vue&type=script&lang=js&"
export * from "./inventory-mask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edad7ae8",
  null
  
)

export default component.exports